<template>
  <div class="cms-confirm">
    <div class="confirm">
      <div class="confirm-title gm-fs-16">
        {{modalTitle}}
      </div>
      <div class="confirm-button" v-if="haveCancel">
        <div class="button-cancel" @click="cancel">{{modalButtonCancel}}</div>
        <div class="button-ok" @click="ok">{{modalButtonOk}}</div>
      </div>
      <div class="confirm-button-nocancel" v-else @click="ok">
        {{modalButtonOk}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/style/func.scss';

.cms-confirm {
  z-index: 99;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: color(000, fl, 0.4);
  .confirm {
    width: px2rem(300px);
    border-radius: px2rem(4px);
    background: color(ff, white);
    position: relative;
    .confirm-title {
      padding: px2rem(40px) px2rem(27px);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      vertical-align: middle;
    }
    .confirm-button-nocancel {
      height: px2rem(50px);
      border-top: 1px solid #EFEFF1;
      box-sizing: border-box;
      font-size: px2rem(16px);
      color: #4A90E2;
      display: flex;
      justify-content: center;
      align-items: center
    }
    .confirm-button {
      display: flex;
      height: px2rem(50px);
      border-top: 1px solid #EFEFF1;
      box-sizing: border-box;
      .button-cancel,.button-ok {
        width: 50%;
        font-size: px2rem(16px);
        color: #4A90E2;
        display: flex;
        justify-content: center;
        align-items: center
      }
      .button-cancel {
        border-right: 1px solid #EFEFF1;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/Confirm/Confirm.vue